<template>
  <transition name="fade" appear>
    <div class="pinch-modal">
      <button class="pinch-modal-close pz-zoom-button" @click="$emit('close')" />
      <pinch-zoom disable-zoom-control="never">
        <img :src="src">
      </pinch-zoom>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'PinchModal',
  props: {
    src: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss">
.pinch-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 999999;
}

.pinch-modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 50px;
  color: #ccc;
  z-index: 1;
  background-image: none;

  &:before,
  &:after {
    content: '';
    display: block;
    height: 4px;
    width: 70%;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    background-color: #ccc;
    transform: rotate(45deg);
    border-radius: 2px;
  }

  &:after {
    transform: rotate(135deg);
  }
}
</style>
